import React from 'react'
import { styled } from 'linaria/react'

const VideolyMetaField = styled.div`
   display: none;
`

export const VideolyMeta = ({ product }) => (
   <>
      <VideolyMetaField id="videoly-product-title">
         {product?.title}
      </VideolyMetaField>
      <VideolyMetaField id="videoly-product-id">
         {product?.articleNumber}
      </VideolyMetaField>
   </>
)
